import { render, staticRenderFns } from "./SelfEmployedViewPage.vue?vue&type=template&id=13f2f534&"
import script from "./SelfEmployedViewPage.vue?vue&type=script&lang=js&"
export * from "./SelfEmployedViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports